export default __webpack_public_path__ + "static/media/03.66d2d662.png";